import { createAsyncThunk } from "@reduxjs/toolkit";
import { loadingActions } from "../LoaderSlice";
import { modalActions } from "../ModalSlice";
import { JEDI_HR_URL } from "../../constants";
import axiosClient from "../../utils/axiosClient";

export const login = createAsyncThunk(
  "auth/login",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside login thunk: ", payload);

    const baseURL = "https://" + JEDI_HR_URL;
    const path = "/login_details";
    const url = baseURL + path;
    console.log("\n\nurl: ", url);

    if (payload === '' || payload === null || payload === undefined) {
      payload = { employee_id: getState().auth.employeeID }
    }

    try {
      const response = await axiosClient.post(url, payload);

      console.log("Login In token : ", response?.data);
      console.log("login Response", response);
      dispatch(loadingActions.setLoading(false));

      if (response?.data?.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message: response?.data?.error_message || response?.data?.message,
            status: "error",
            state: true,
          })
        );
      }
      return response.data;
    } catch (error) {
      console.log("Error getSignInToken: ", error);
      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: "error",
          state: true,
        })
      );
      return rejectWithValue(error);
    }
  }
);

export const getUserDetails = createAsyncThunk(
  "auth/get_user_details",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside getUserDetails : ", payload);

    const baseURL = "https://" + JEDI_HR_URL;

    const path = "/get_user_details";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      dispatch(loadingActions.setLoading(false));
      console.log("getUserDetails response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          })
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error :  ", error.message);

      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        })
      );
      return rejectWithValue(error);
    }
  }
);

export const updateUserProfileInfo = createAsyncThunk(
  "people/updateUserProfileInfo",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside updateUserProfileInfo : ", payload);

    const baseURL = "https://" + JEDI_HR_URL;

    const path = "/update_user_details";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      dispatch(loadingActions.setLoading(false));
      console.log("updateUserProfileInfo response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          })
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error :  ", error.message);

      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        })
      );
      return rejectWithValue(error);
    }
  }
);
